import React  from "react";
import './chart.scss'
import 'chart.js/auto';
import { Chart } from 'react-chartjs-2';

export default function Charts({LableProjectList,WalkList,CallList,OnlineList,WalkonList,RsList,RcList})
{
return (
  <div className='feature'>
      <div className="top">
        <h1 className="title">จำนวนลูกค้า/ยอดจอง</h1>      
      </div>
            <Chart width={60} height={30}
            type='bar' data={{
                  labels: LableProjectList.map( person => person.ProjectShortName),
                  datasets: [
                  { 
                    label: "Walk-in",
                    data:WalkList.map( person => person.Value),
                    borderColor: '#f48fb1',
                    backgroundColor: '#f48fb1'
                  },{ 
                    label: "Call",
                    data:CallList.map( person => person.Value),
                    borderColor: '#81d4fa',
                    backgroundColor: '#81d4fa'
                  },{ 
                    label: "Online-Contact",
                    data:OnlineList.map( person => person.Value),
                    borderColor: '#ffb74d',
                    backgroundColor: '#ffb74d'
                  },{ 
                    label: "Walk-in Online",
                    data: WalkonList.map( person => person.Value),
                    borderColor: '#69f0ae',
                    backgroundColor: '#69f0ae'
                  },{ 
                    label: "จองเข้าระบบ",
                    data: RsList.map( person => person.Value),
                    borderColor: '#957DAD',
                    backgroundColor: '#957DAD'
                  },{ 
                    label: "จองเช็คธนาคาร",
                    data:RcList.map( person => person.Value),
                    borderColor: '#ffff00',
                    backgroundColor: '#ffff00'
                  }],
                  options: {
                    scales: {
                      y: {
                        beginAtZero: true
                      }
                    }
                  }
                }}/>
      </div>
)
}